import { Button } from "components/DesignSystem/Button/Button";
import { REGISTERED_AGENT } from "constants/addons";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useDispatch } from "react-redux";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import { setAddonData, setAddonType } from "store/slices/addons";
import { LargeCard } from "components/home/Home";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";

export const RAHomeCard = ({ isRASubscribed }: { isRASubscribed: boolean }) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();
  const { data: allSubscriptions = [] } = useGetSubscriptionsQuery(
    {
      groupId,
      entityId,
    },
    {
      skip: !entityId || !groupId,
    }
  );
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const history = useHistory();

  const registeredAgents = allSubscriptions.filter(
    (ele) => ele.subscription_type === REGISTERED_AGENT
  );

  const registeredAgentMinAmount = registeredAgents?.reduce((min, obj) => {
    return Number(obj?.amount) < Number(min)
      ? Number(obj?.amount)
      : Number(min);
  }, Number(registeredAgents?.[0]?.amount));

  const registeredAgentStateMappings =
    registeredAgents
      ?.filter((ele) => ele.group_subscription)
      ?.map((ele) => {
        return {
          amount: ele?.amount,
          selectedStates: ele?.group_subscription,
          type: ele?.metadata?.ra_state,
          uuid: ele?.uuid,
        };
      }) || [];

  const registeredAgentUnselectedStates = registeredAgents
    ?.filter((ele) => !ele.group_subscription)
    ?.map((ele) => {
      return {
        amount: ele?.amount,
        type: ele?.metadata?.ra_state,
        uuid: ele?.uuid,
        ra_state: ele?.metadata?.ra_state,
      };
    });

  const registeredAgent = {
    amount: registeredAgentUnselectedStates.find(
      (ele) => ele.ra_state === "Others"
    )?.amount,
    billing_cycle: "MONTHLY",
    description:
      "Registered Agent service for all states of the United States of America",
    subscription_name: "Registered Agent",
    subscription_type: REGISTERED_AGENT,
    ...(registeredAgentStateMappings?.length > 0
      ? { group_subscription: registeredAgentStateMappings }
      : {}),
    unselectedStates: registeredAgentUnselectedStates,
    ra_state_amount_maps: registeredAgentUnselectedStates,
    uuid: registeredAgents[0]?.uuid,
  };

  const { link } = useConstructInternalLink();

  const openRAAddon = () => {
    if (isRASubscribed) {
      history.push(link(`${url}/registered-agent`));
      return;
    }
    dispatch(setAddonData(registeredAgent));
    dispatch(setAddonType(REGISTERED_AGENT));
  };

  const btnText = isRASubscribed ? "View more" : "Get started";

  return (
    <>
      <div className="t-pb-8 t-grid t-gap-6 t-flex-wrap md:t-grid-cols-[repeat(auto-fill,minmax(462px,1fr))] t-grid-cols-[repeat(auto-fill,1fr)]">
        <LargeCard>
          <div
            role="button"
            onClick={openRAAddon}
            className="t-border t-border-solid t-border-neutral-0 t-rounded-lg t-p-5 t-h-full t-w-full t-bg-[url('static/images/RegisteredAgentCardBG.svg')] t-bg-no-repeat t-bg-center"
          >
            <div className="t-h-full t-w-1/2 t-flex t-flex-col t-justify-between">
              <div className="t-w-full">
                <div className="t-text-subtitle t-text-text-100">
                  Inkle Registered Agent
                </div>
                <span className="t-text-body-sm t-text-text-30 t-mb-10">
                  Manage your registered agent services for all states.
                </span>
              </div>
              <div>
                <Button size="small">{btnText}</Button>
              </div>
            </div>
          </div>
        </LargeCard>
      </div>
    </>
  );
};
